export async function copyAuthorizationCode(code, clipboard) {
    const writer = clipboard ?? globalThis.navigator?.clipboard;
    if (writer === undefined)
        throw new Error('Clipboard access is unavailable');
    await writer.writeText(code);
}
//# sourceMappingURL=authorization-code-clipboard.js.map